import { authFetch, BASE_BACKEND_URL } from '../../auth'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProductsPriceListTab from './ProductsPriceListTab'
import ClientsPriceListTab from './ClientsPriceListTab'
import HistoryPriceList from './HistoryPriceList'
import LoadingScreen from '../../components/LoadingScreen'
import { buildPriceListApiUrl } from './helpers/priceListUrlHelpers'

const ShowPriceListView = (props) => {
  const { id } = useParams()
  const [activeTab, setActiveTab] = useState('Clientes')
  const [dbRef, setDbRef] = useState('')
  const [description, setDescription] = useState('')
  const [isFetching, setIsFetching] = useState(true)

  useEffect(() => {
    fetchPriceListDetails()
  }, [])

  const fetchPriceListDetails = () => {
    setIsFetching(true)
    authFetch(buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists', id), {
      method: 'GET',
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setDbRef(data.price_list.db_ref)
        setDescription(data.price_list.description)
      })
      .catch((e) => console.log(e))
      .finally(() => setIsFetching(false))
  }

  const handleTabClick = (event) => {
    if (event.target.tagName === 'A') {
      setActiveTab(event.target.innerText)
    }
  }

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      <div className="main-show-header">
        <h2>
          Lista de Precio: {dbRef} - {description}
        </h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <div>
            <div onClick={handleTabClick}>
              <ul className="nav nav-tabs">
                <li id="clientes_tab" className="nav-item">
                  <a
                    className={`nav-link ${activeTab === 'Clientes' ? 'active' : 'inactive-tab'
                      } cursor-pointer`}
                  >
                    Clientes
                  </a>
                </li>
                <li id="productos_tab" className="nav-item">
                  <a
                    className={`nav-link ${activeTab === 'Productos' ? 'active' : 'inactive-tab'
                      } cursor-pointer`}
                  >
                    Productos
                  </a>
                </li>
                <li id="historial_tab" className="nav-item">
                  <a
                    className={`nav-link ${activeTab === 'Historial' ? 'active' : 'inactive-tab'
                      } cursor-pointer`}
                  >
                    Historial
                  </a>
                </li>
              </ul>
            </div>
            <div>
              {activeTab === 'Clientes' && (
                <div>
                  <ClientsPriceListTab id={id} />
                </div>
              )}
              {activeTab === 'Productos' && (
                <div>
                  <ProductsPriceListTab id={id} />
                </div>
              )}
              {activeTab === 'Historial' && (
                <div>
                  <HistoryPriceList dbRef={dbRef} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ShowPriceListView
